export default "__VITE_ASSET__DyMkXecO__"